import { PlatformFaqComponent } from './platform-faq/platform-faq.component';
import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { StaticPageComponent } from './static-page/static-page.component';
import { SharedModule } from "../shared/shared.module";
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeModule } from '../home/modules/home.module';
import { RouterModule } from '@angular/router';
import { SitemapComponent } from './sitemap/sitemap.component';

@NgModule({
  declarations: [
    PrivacyPolicyComponent,
    AboutUsComponent,
    ContactUsComponent,
    StaticPageComponent,
    PlatformFaqComponent,
    SitemapComponent
  ],
  exports: [
    AsyncPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    HomeModule,
    NgbModule,
    NgbAccordionModule,
    // routerLink for the sitemap links
    RouterModule
  ]
})
export class StaticPagesModule { }
